import { Component, OnInit } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'improvement-plan',
  templateUrl: './improvement-plan.component.html',
  styleUrls: ['./improvement-plan.component.scss'],
})
export class ImprovementPlanComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
